import { useContext } from 'react'
import DialogActionButtonsSection from './components/DialogActionButtonsSection'
import { AppContext, AppContextType, VbAudioCableAutoDeselectionInfo } from '../AppContext'
import { UserContext, UserContextType } from '../UserContext'
import useMediaSelectionActions from '../actions/useMediaSelectionActions'
import CrossPlatformDialog from './components/CrossPlatformDialog'
import { DialogBody, DialogTitle } from '@/components/Dialog'

export default function VbAudioCableAutoDeselectionDialogController() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType
    const { state, dispatch } = useContext(UserContext) as UserContextType

    const { mkAudioInputSelection } = useMediaSelectionActions()

    const info = appState.appState.showVbAudioCableAutoDeselectionDialog
    const isMusePluginDetected = appState.appState.musePluginState.isConnected

    const dialogTitle = isMusePluginDetected ? 'Muse Plugin Detected' : 'VB Cable is in use'

    const mkDialogBody = (info: VbAudioCableAutoDeselectionInfo) => {
        if (info.deviceToDeselect.deviceId.startsWith('__internal_muse_daw_bridge')) {
            return [
                'VB Audio Cable is currently being used by the Muse plugin.',
                'Would you like to share computer audio instead?',
            ]
        } else {
            return [
                'VB Audio Cable is currently being used to share computer audio.',
                'Would you like to share audio from the Muse plugin instead?',
            ]
        }
    }

    const onCloseDialog = () => {
        appDispatch({
            type: 'update_app_state',
            value: { showVbAudioCableAutoDeselectionDialog: null },
        })
    }

    const onConfirm = (info: VbAudioCableAutoDeselectionInfo | null) => {
        if (info) {
            const audioInputsNext = state.mediaSelection.audioInputs.filter(
                (a) => a.deviceId !== info.deviceToDeselect.deviceId
            )
            const s = mkAudioInputSelection(info.selectedDevice)
            if (s) {
                audioInputsNext.push(s)
                dispatch({
                    type: 'update_media_selection',
                    value: {
                        audioInputs: audioInputsNext,
                    },
                })
            }
        }
        onCloseDialog()
    }

    if (info == null) {
        return null
    }

    return (
        <CrossPlatformDialog frameName="Dialog:VbAudioCableAutoDeselectionDialog" onDefaultClose={onCloseDialog}>
            <DialogBody>
                <DialogTitle>{dialogTitle}</DialogTitle>

                {mkDialogBody(info).map((line) => {
                    return <div className="pb-3">{line}</div>
                })}
            </DialogBody>

            <DialogActionButtonsSection
                leftButtonText="No"
                rightButtonText="Yes"
                onLeftButtonClicked={onCloseDialog}
                onRightButtonClicked={() => onConfirm(info)}
            />
        </CrossPlatformDialog>
    )
}
